import { lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router'
import Home from './pages/Home.jsx'
import LinkInterceptor from './components/LinkInterceptor.jsx'

// The home page is bundled up front (and prerendered); the listaa sign-up flow loads on first visit.
const ListaaLayout = lazy(() => import('./ListaaLayout.tsx'))
const ForVenues = lazy(() => import('@/app/pages/ForVenues'))
const VenueSubmission = lazy(() => import('@/app/pages/VenueSubmission'))
const PhoneVerification = lazy(() => import('@/app/pages/PhoneVerification'))
const EmailVerification = lazy(() => import('@/app/pages/EmailVerification'))
const VenueDashboard = lazy(() => import('@/app/pages/VenueDashboard'))
const ForgotPassword = lazy(() => import('@/app/pages/ForgotPassword'))
const ResetPassword = lazy(() => import('@/app/pages/ResetPassword'))
const Login = lazy(() => import('@/app/pages/Login'))
const AccountVerify = lazy(() => import('@/app/pages/AccountVerify'))
// Venue accounts only; the guard loads with the page so the home bundle stays light.
const AccountSettings = lazy(() => Promise.all([
  import('@/app/pages/AccountSettings'),
  import('@/app/components/RequireAuthenticatedAuth'),
]).then(([page, guard]) => ({
  default: () => <guard.RequireAuthenticatedAuth><page.default /></guard.RequireAuthenticatedAuth>,
})))
const Pricing = lazy(() => import('@/app/pages/Pricing'))
const Contact = lazy(() => import('@/app/pages/Contact'))
const OAuthCallback = lazy(() => import('@/app/pages/OAuthCallback'))
const legal = (name) => lazy(() => import('@/app/pages/Legal').then((m) => ({ default: m[name] })))
const PrivacyPolicy = legal('PrivacyPolicy')
const TermsOfService = legal('TermsOfService')
const CookiePolicy = legal('CookiePolicy')
const CommunityGuidelines = legal('CommunityGuidelines')

export default function App() {
  return (
    <>
      <LinkInterceptor />
      <Routes>
        <Route index element={<Home />} />
        <Route element={<ListaaLayout />}>
          <Route path="add-venue" element={<ForVenues />} />
          <Route path="steps/:step" element={<VenueSubmission />} />
          <Route path="steps" element={<Navigate to="/steps/venue-information" replace />} />
          <Route path="verify-phone" element={<PhoneVerification />} />
          <Route path="verify-email" element={<EmailVerification />} />
          <Route path="verify" element={<AccountVerify />} />
          <Route path="account-settings" element={<AccountSettings />} />
          <Route path="venue-dashboard" element={<VenueDashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route path="reset-password" element={<Navigate to="/forgot-password" replace />} />
          <Route path="social-oauth/:provider/callback" element={<OAuthCallback />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route path="cookies" element={<CookiePolicy />} />
          <Route path="community-guidelines" element={<CommunityGuidelines />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}
